import { formatMultiplierTenths } from './lightning-types.js';

export interface ResultCalculationInput {
  matchCount: number;
  baseProfitMultiplierTenths: number;
  lightningProfitMultiplierTenths: number;
  stakeReturnMultiplierTenths: number;
  totalPayoutMultiplierTenths: number;
}

/** Builds the single-line payout formula shown during normal gameplay. */
export function buildResultCalculationLine(input: ResultCalculationInput): string {
  const total = formatMultiplierTenths(input.totalPayoutMultiplierTenths);
  if (input.matchCount === 0) {
    return `No matches · Total ${total}`;
  }

  const parts: string[] = [];
  if (input.baseProfitMultiplierTenths > 0) {
    parts.push(`Base ${formatMultiplierTenths(input.baseProfitMultiplierTenths)}`);
  }
  if (input.lightningProfitMultiplierTenths > 0) {
    parts.push(`Lightning ${formatMultiplierTenths(input.lightningProfitMultiplierTenths)}`);
  }
  if (input.stakeReturnMultiplierTenths > 0) {
    parts.push(`Stake ${formatMultiplierTenths(input.stakeReturnMultiplierTenths)}`);
  }
  return `${parts.join(' + ')} = Total ${total}`;
}

export interface ResultMoneySublineInput {
  profitAmountMinor: number;
  totalPayoutAmountMinor: number;
  currency: string;
  formatMoney: (minor: number, currency: string) => string;
}

/** Optional compact money line when space allows. */
export function buildResultMoneySubline(input: ResultMoneySublineInput): string {
  const profit = input.formatMoney(input.profitAmountMinor, input.currency);
  const total = input.formatMoney(input.totalPayoutAmountMinor, input.currency);
  return `Profit ${profit} · Total payout ${total}`;
}
